<template>
	<div class="d-flex flex-wrap">
		<v-col cols="12" class="px-0 pb-0">
			<v-row class="ml-0 mt-0">
				<v-col cols="12" class="pl-0 pt-0">
					<div class="cl-grey font-size-12 font-weight-500">Ringkasan Transaksi</div>
				</v-col>
				<v-col cols="12" class="pl-0 pt-0">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
						<div class="d-flex flex-wrap">
							<v-col cols="6" sm="5" md="5" class="py-0">
								<div class="font-size-11 font-weight-bold">Nama Produk</div>
							</v-col>
							<v-col cols="12" sm="2" md="2" class="d-none d-sm-block py-0">
								<div class="font-size-11 font-weight-bold text-center">Qty</div>
							</v-col>
							<v-col cols="6" sm="5" md="5" class="py-0 text-right">
								<div class="font-size-11 font-weight-bold">Harga</div>
							</v-col>
							<v-col cols="12" class="pa-0" v-for="detail in successResponse.transaction_detail" :key="detail.transaction_detail_product_id">
								<div class="d-flex flex-wrap">
									<v-col cols="6" sm="5" md="5" class="pt-2 pb-0">
										<div class="font-size-xs-10 font-size-11">{{ detail.transaction_detail_product_name }}</div>
										<div class="font-size-xs-10 font-size-11 d-block d-sm-none">x {{ detail.transaction_detail_qty }}</div>
									</v-col>
									<v-col cols="12" sm="2" md="2" class="d-none d-sm-block pt-2 pb-0">
										<div class="font-size-xs-10 font-size-11 text-center">{{ detail.transaction_detail_qty }}</div>
									</v-col>
									<v-col cols="6" sm="5" md="5" class="pt-2 pb-0 text-right">
										<div class="font-size-xs-10 font-size-11">{{ detail.transaction_detail_unit_price | toRupiah }}</div>
									</v-col>
								</div>
							</v-col>
						</div>
						<div class="mt-3 d-flex flex-wrap">
							<v-col cols="12" class="py-0">
								<div class="border-top border-grey border-2px"></div>
							</v-col>
							<v-col cols="6" sm="6" md="6" class="pb-0">
								<div class="font-size-xs-10 font-size-11 font-weight-bold">Total Pembayaran</div>
							</v-col>
							<v-col cols="6" sm="6" md="6" class="pb-0 text-right">
								<div class="font-size-xs-10 font-size-11 font-weight-bold">{{ successResponse.transaction_total_price | toRupiah }}</div>
							</v-col>
						</div>
					</v-card>
					<v-card class="mt-3 pa-3 elevation-0 rounded-xl hover-shadow">
						<div class="d-flex flex-wrap justify-center">
							<v-col cols="6" sm="4" md="3" class="pt-0">
								<v-img src="/assets/ilustration/ilustrasi-confirm-transaction.svg"></v-img>
							</v-col>
							<v-col cols="12" class="pb-0 text-center">
								<div class="font-size-xs-10 font-size-11 font-weight-500">Anda berhasil melakukan pembelian produk !!</div>
							</v-col>
						</div>
						<div class="pt-3 px-3 font-size-xs-10 font-size-11 text-center">Silakan melakukan pembayaran ke salah satu bank dibawah ini sebesar 
							<span class="font-weight-bold">{{ successResponse.transaction_total_price | toRupiah }}</span>
						</div>
						<div class="px-3 pt-1 pb-5">
							<div class="d-flex flex-wrap justify-center">
								<v-col cols="12" sm="4" class="pt-5 pb-0 text-center" v-for="bank in bankCompany" :key="bank.bank_company_id">
									<div class="font-size-xs-10 font-size-11 font-weight-bold">{{ bank.bank_company_name }}</div>
									<div>
										<img width="80px" height="80px" class="rounded-xl" :src="bank.bank_company_bank_logo ? bank.bank_company_bank_logo : require('/public/assets/image/user-pict.jpg')">
									</div>
									<div class="font-size-xs-10 font-size-11 font-weight-bold">{{ bank.bank_company_bank_acc_number }}</div>
									<div class="cl-grey font-size-xs-10 font-size-11">an {{ bank.bank_company_bank_acc_name }}</div>
								</v-col>
							</div>
						</div>
						<v-col cols="12" class="pt-5 pb-1 text-center">
							<v-btn outlined color="primary" height="45" class="white--text rounded-xl text-capitalize font-weight-bold" @click="goUploadBukti(successResponse.transaction_code)">
								<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Upload Bukti Pembayaran</span>
								<v-icon>mdi-upload-outline</v-icon>
							</v-btn>
							<div class="font-size-xs-10 font-size-11 py-2">atau</div>
							<v-btn depressed color="primary" height="45" class="white--text rounded-xl text-capitalize font-weight-bold" @click="reloadPage">
								<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Beli Produk Lagi</span>
								<v-icon>mdi-cart-outline</v-icon>
							</v-btn>
						</v-col>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			params: {},
		}
	},
	props: {
	},
	computed: {
		...mapState('opsi', ['bankCompany']),
		...mapState(['successResponse'])
	},
	methods: {
		...mapActions('opsi', ['getBankCompany']),

		goUploadBukti(code) {
			this.$router.push({ name: 'detail-pembelian', params: {type: 'upload', slug: code} })
		},
		reloadPage() {
			this.$router.go(this.$router.currentRoute)
		},
	},
	created() {
		this.getBankCompany()
	},
};
</script>